/**
 * 故障统计
 */
import React, {useEffect, useRef, useState} from 'react'
import moment from 'moment';
import {DatePicker, Spin} from 'antd';
const { RangePicker } = DatePicker;
import 'moment/locale/zh-cn';
import {AuthButton, ExportFile, StatisticsDate,WWTable,DeviceSearch,SimpleTreeUpdate} from "@/globalComponents";
import {WWMethods, WWUtils,wwConstants,} from "@/tools";
moment.locale('zh-cn');
export default function ForkliftStatisticsSummary(props) {
    const [dates, setDates] = useState([moment().subtract(1, 'day'),moment().subtract(1, 'day')]);
    const [organizationId,setOrganizationId] =useState(props.organizationId || localStorage.getItem("organizationId"));
    const [organizationName,setOrganizationName] = useState(localStorage.getItem("organizationName"))
    const [value, setValue] = useState([]);
    const [pageSize,setPageSize] = useState(10);
    const [currentPage,setCurrentPage] = useState(1);
    const [carId, setCarId] = useState('');
    const [beanList, setBeanList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [winH,setWinH] = useState(window.innerHeight);
    const [winW,setWinW] = useState(window.innerWidth);
    const [count,setCount] = useState(0);
    const [choosedValue,setChoosedValue] = useState("yestaday")
    const dateRef = useRef(null);
    const deviceRef = useRef(null);
    const isInitialMount = useRef(true);
    const vinlist_tree_Ref = useRef(null);

    useEffect(() => {
        // 页面变化时获取浏览器窗口的大小
        window.addEventListener('resize',onWindowResize);
        return()=>{
            // 组件销毁时移除监听事件
            window.removeEventListener('resize',onWindowResize);
        }
    }, []);
    useEffect(()=>{
        vinlist_tree_Ref.current.updateDatas_simple({
            treeVisible:false,
            popVisible:false,
            showSelect:true,
            expandKeys:[localStorage.getItem("organizationId").toString()],
            organizationName:Strings.selectorg || "请选择门店",
            selectedKeys:[localStorage.getItem("organizationId").toString()],
            organizationId:"",
            showRootName:false,
            isTallTree:true
        });
    },[])
    useEffect(() => {
        //控制在组件挂载时不触发getCount
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            getCount();
        }
    }, [currentPage,pageSize]);

    //视窗变化
    const onWindowResize = ()=> {
        setWinH(window.innerHeight);
        setWinW(window.innerWidth)
    }
    //重置查询参数
    const resetParams = () => {
        setDates([moment().subtract(1, 'day'),moment().subtract(1, 'day')])
        setValue([]);
        setCarId('');
        setLoading(false)
        setOrganizationId("")
        dateRef.current.updateDatePickerTime({ target: { value: 'yestaday' } });
        deviceRef.current.resetSearchValue(null);
        vinlist_tree_Ref.current.setState({organizationName:Strings.selectorg || "请选择门店"})
    }
    //不可选取时间
    const disabledDate = (current) => {
        return WWMethods.disabledDate(current,dates)
    };
    //时间按钮组件操作
    const changeTime = (startTime, endTime) => {
        setDates([startTime,endTime])
    };
    const handleChoosedValueChange = (value) => {
        setChoosedValue(value)

    };
    //日历控件操作

    const onOpenChange = (open) => {
        WWMethods.onOpenChange(open,()=>{
            setDates([null, null]);
        },()=>{
            setDates(null);
        })
    }
    function formatSearchParams() {
        let timeRange
        if(dates){
            timeRange = WWUtils.getTimeFromCalendar(dates);
        }else {
            timeRange = WWUtils.getTimeFromCalendar(value);
        }
        return {
            carId,
            timeRange,
            currentPage,
            pageSize,
            orgId:organizationId,
        }
    }
    const onShowSizeChange = (curPage, pSize)=>{
        setCurrentPage(curPage);
        setPageSize(pSize);
    }

    //获取count
    const getCount = ()=>{
        WWMethods.getForkliftStatisticsSummaryCount(formatSearchParams(),(data)=> {
                setCount(data);
                getList();
        })
    }
    //获取列表数据
    const getList = ()=>{
        setLoading(true)
        WWMethods.getForkliftStatisticsSummaryList(formatSearchParams(),(data)=> {
            setLoading(false)
            if(data.code === 0) {
                setBeanList(data.data);
            }
        })
    }

    const handleDeviceChange = (carId) => {
        setCarId(carId)
    };

    const handleAccountChange = (id,name)=>{
        setOrganizationId(id);
        setOrganizationName(name)

    }

    const goAlarmDetail = (record,alarmType) => {
        if (props.setSwitch) {
            if(dates){
                props.setSwitch(record,alarmType,choosedValue,dates[0],dates[1])
            }else {
                props.setSwitch(record,alarmType,choosedValue,value[0],value[1])
            }
        }

    }
    //表头上的报警类型由后端数据遍历而来
    const alarmTypes = WWUtils.getOptionsFromGlobalEnums("enums.forkliftFaultType","")
    const columns = [
        {
            title: Strings.orgName || "所属用户" ,
            dataIndex: 'orgName',
            width:'150px'
        },
        {
            title: Strings.carCode || "机械编号",
            dataIndex: 'carCode',
            width:'200px',
        },
        {
            title: Strings.imei || "设备号",
            dataIndex: 'imei',
            width:'180px',
        },
        ...alarmTypes.map((alarmType) => ({
            title:  alarmType.name,
            dataIndex: alarmType.code,
            width: "180px",
            render: (text, record) => {
                if(record.faultMap){
                    let detail_html = record.faultMap[alarmType.code]?<span><a onClick={()=>{goAlarmDetail(record,alarmType)}}>{record.faultMap[alarmType.code]}</a></span>:<span>0</span>
                    return WWUtils.checkPermission('5-6-4')?detail_html:null
                }else {
                    return <span>0</span>
                }
            },
        })),
    ];


    return (
            <Spin spinning={loading}>
                <div id={"alarmsummary_search"} className={"searchWrapper mgb15"}>
                    <div className={"firstRow searchRow alt"}>
                        <div className={"searchDiv"}>
                            <div className="searchItem">
                                <div className={"items"}>
                                    <div className={"item"}>
                                        <label className={"labelfont"}>{Strings.orgName || "所属用户"}</label>
                                        <div className={`alarmSummary_tree_wrapper tree_wrapper`} style={{display:"inline-block",position:"relative",marginLeft:7}}>
                                            <SimpleTreeUpdate ref={vinlist_tree_Ref}
                                                              selectWidth={240}
                                                              margins={"5px auto"}
                                                              organizationId={organizationId}
                                                              parentClass={`alarmSummary_tree_wrapper`}
                                                              directShowTree={false}
                                                              showRootName={false}
                                                              handleChange={handleAccountChange}
                                                              sendAccountId={handleAccountChange}
                                            />
                                        </div>
                                    </div>
                                    <div className={"item w240"}>
                                        <DeviceSearch ref={deviceRef} className={"mg15"} onChange={handleDeviceChange}/>
                                    </div>
                                    <div className={"item w240"}></div>
                                </div>
                                <div className={"mgt15 item"}>
                                    <StatisticsDate
                                        ref={dateRef}
                                        isShowToday={true}
                                        changeTime={changeTime}
                                        onChoosedValueChange={handleChoosedValueChange}
                                        dateFormat={wwConstants.timeSet.dateFormatWithOutHMS}
                                        choosedValue={'yestaday'}/>
                                    <RangePicker
                                        value={dates || value}
                                        onCalendarChange={(val) => {
                                            setDates(val);
                                        }}
                                        format={wwConstants.timeSet.dateFormatWithOutHMS}
                                        onChange={(val) => {
                                            setValue(val);
                                        }}
                                        onOpenChange={onOpenChange}
                                        disabledDate={disabledDate}/>
                                </div>
                            </div>
                        </div>
                        <div className={"btnswrapper"}>
                            <AuthButton className={"mgl30 widauto"} type="primary" authKey={true} onClick={() => {
                                currentPage !== 1 ? setCurrentPage(1) : getCount()
                            }}>{Strings.search || "搜索"}</AuthButton>
                            <AuthButton className={"mgl10 mgt15 widauto"} type="reset" authKey={true} onClick={resetParams}>{Strings.reset || "重置"}</AuthButton>
                        </div>
                    </div>
                </div>

                <div className="border_table">
                    <div className={"bathOptsWrapper"}>
                        <div className={"leftopts"}></div>
                        <ExportFile params={formatSearchParams()} type={"forkliftFaultStatistic"} authKey1={WWUtils.checkPermission('5-6-1-1')} authKey2={WWUtils.checkPermission('5-6-1-2')}></ExportFile>
                    </div>
                    <WWTable className="new_app_table"
                             bordered={false}
                             columns={columns}
                             pagination={false}
                             dataSource={beanList}
                             innerHeight={winH-328}
                             width={winW-231}
                             pageSize={pageSize}
                             count={count}
                             currentPage={currentPage}
                             onChange={onShowSizeChange}
                             onShowSizeChange={(currentPage,pageSize)=>{
                                 onShowSizeChange(1,pageSize)
                             }}/>
                </div>
            </Spin>
    )

}

